import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgWebhook = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M20.471 16.373h-.01m-2.614 0h-.918m-7.922 0h5.178m-5.177-3.45-5.479 3.45 5.479 3.451zM3.529 7.627h.01m2.614 0h.918m7.922 0H9.815m5.177-3.451 5.479 3.451-5.479 3.451z"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgWebhook);
export default ForwardRef;
